<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='compras' :items='compras' :search='search' sort-by='fechaCreacion' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar.header-toolbar-compras(flat color='primary' dark)
            v-flex(class="d-flex flex-wrap justify-center")
              v-toolbar-title.main-head Compras
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success' class="search")
              v-spacer
              v-dialog(v-model='dialog' scrollable persistent content-class="flex xs12 sm8")
                template(v-slot:activator='{ on }')
                  v-btn.btn-main.mx-2(v-if='validarCrear()' fab dark small color='success' v-on='on')
                    v-icon(dark) mdi-plus
                  v-btn.btn-main(color='success' dark @click='pendientes' v-if="mostrarPen")
                      | Sin Nro.Factura.
                  v-btn.btn-main(color='success' dark @click='pendientes' v-else)
                      | Facturas
                v-card(color='grey_1')
                  v-app-bar(dark color='primary')
                    v-toolbar-title.sub-head {{ formTitle }}
                    v-spacer
                    v-btn(color='success' dark @click='editFact' v-if='editedIndex > -1 && editedItem.numFactura == "Sin Nro.Factura."')
                      | Agregar Nro.Factura.
                  v-card-text
                    v-row(dense)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Facturación
                          v-card-text
                            v-row(dense v-if="editedIndex === -1")
                              v-col(cols='12' sm='6')
                                v-select(dense outlined label="Tipo de Documento" v-model='doc' :items="documentos" @change="DocumentoSeleccionado")
                              v-col(cols='12' sm='6')
                                v-autocomplete(autocomplete="off" dense outlined v-model='editedItem.tipoCompra' :items='tipoCom' id="tipoCom" label='Tipo de Compra' :readonly='read')
                            v-row(dense v-if="mostrarFact")
                              //- Nro.Factura
                              v-col(cols='12' sm='12' md='6' v-if="!read2")
                                v-text-field(dense outlined v-model='editedItem.numFactura' id="nrofactura" label='Nro.Factura' :readonly='read2')
                              v-col(cols='12' sm='12' md='6' v-else)
                                v-text-field(dense outlined v-model='editedItem.numFactura' id="nrofactura" label='Nro.Factura' :readonly='read2')
                              //- Fecha de Emision Factura Compra
                              v-col(cols='12' sm='12' md='6' v-if="!read2")
                                v-dialog(ref='dialog1' scrollable v-model='modalEmi', :return-value.sync='dateEmision' persistent content-class="flex xs12 sm6" )
                                  template(v-slot:activator='{ on }')
                                    v-text-field(v-model='editedItem.fechaEmision' label='Fecha Emision de Factura' prepend-icon='event' readonly dense outlined v-on='on')
                                  v-date-picker(v-model='editedItem.fechaEmision' locale="ES")
                                    v-spacer
                                    v-btn(small dark color='red' @click='modalEmi = false') Cancelar
                                    v-btn(small dark color='success' @click='$refs.dialog1.save(dateEmision)') Ok
                              v-col(cols='12' sm='12' md='6' v-else)
                                v-text-field(v-model='editedItem.fechaEmision' label='Fecha de Emision' prepend-icon='event' readonly dense outlined)
                            v-row(dense v-if="mostrarFact")
                              v-col(cols='12' sm='12' md='6' v-if="!read2")
                                v-dialog(ref='dialog2' scrollable v-model='modalEmiVen', :return-value.sync='dateEmisionVen' persistent content-class="flex xs12 sm6" )
                                  template(v-slot:activator='{ on }')
                                    v-text-field(v-model='editedItem.fechaVencimiento' label='Fecha Vencimiento de Factura' prepend-icon='event' readonly dense outlined v-on='on')
                                  v-date-picker(v-model='editedItem.fechaVencimiento' locale="ES")
                                    v-spacer
                                    v-btn(small dark color='red' @click='modalEmiVen = false') Cancelar
                                    v-btn(small dark color='success' @click='$refs.dialog2.save(dateEmisionVen)') Ok
                              v-col(cols='12' sm='12' md='6' v-else)
                                v-text-field(v-model='editedItem.fechaVencimiento' label='Fecha de Vencimiento' prepend-icon='event' readonly dense outlined)
                            v-row(dense v-if="mostrarNota && editedIndex === -1")
                              //- Nota de Entrega
                              v-col(cols='12' sm='12' md='6')
                                v-text-field(
                                  dense,
                                  outlined,
                                  v-model='editedItem.notaEntrega',
                                  id="notaentrega",
                                  label='Cod. Nota Entrega',
                                  :readonly='read',
                                  v-uppercase)
                              //- Fecha de Emision Nota entrega
                              v-col(cols='12' sm='12' md='6')
                                v-dialog(ref='dialog1' scrollable v-model='modalEmiNota', :return-value.sync='dateEmisionNota' persistent content-class="flex xs12 sm6" )
                                  template(v-slot:activator='{ on }')
                                    v-text-field(v-model='editedItem.fechaEmisionNota' label='Fecha Emision Nota Entrega' prepend-icon='event' readonly dense outlined v-on='on')
                                  v-date-picker(v-model='editedItem.fechaEmisionNota' locale="ES" )
                                    v-spacer
                                    v-btn(small dark color='red' @click='modalEmiNota = false') Cancelar
                                    v-btn(small dark color='success' @click='$refs.dialog1.save(dateEmisionNota)') Ok
                            v-row(dense v-if="editedIndex > -1 && editedItem.notaEntrega !== 'No tiene.'")
                              //- Nota de Entrega
                              v-col(cols='12' sm='12')
                                v-text-field(
                                  dense,
                                  outlined,
                                  v-model='editedItem.notaEntrega',
                                  id="notaentrega",
                                  label='Cod. Nota Entrega',
                                  :readonly='read',
                                  v-uppercase)
                              v-col(cols='12' sm='12')
                                v-text-field(v-model='editedItem.fechaEmisionNota' label='Fecha Emision Nota Entrega' prepend-icon='event' readonly dense outlined)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Moneda
                          v-card-text
                            //- Moneda
                            v-row(v-if="editedIndex === -1" dense)
                              v-col(cols='6' sm='4')
                                v-switch(dense color='success' v-model='editedItem.dolar' label='Dolar' @change="cambiarMonedaBs()")
                              v-col(cols='6' sm='4')
                                v-switch(dense color='success' v-model='editedItem.bs' label='Bs' @change="cambiarMonedaDolar()" )
                            v-row(dense)
                              v-col(cols='12' sm='12' md='6')
                                v-text-field(dense outlined @keydown="validarTasa(editedItem.tasaCompra)" v-model.number="editedItem.tasaCompra" label='Tasa de la Compra' prefix="BsS")
                      v-col( cols='12')
                        v-card(color='white' v-if='!config.ordenCompra.valor')
                          v-card-subtitle.title(style='color: black') Orden de Compra
                          v-card-text
                            //- Orden de Compra
                            v-row(dense)
                              v-col(cols='12' sm='12' md='4' v-if="!read")
                                v-autocomplete(dense autocomplete="off" outlined v-model='editedItem.nroOrden' :items="idOrdenesArray"
                                  @change="OrdenSeleccionada" label='Nro.Orden' :readonly='read')
                              v-col(cols='12' sm='6' md='4' v-if="!read")
                                v-text-field(dense outlined readonly v-model='nombreProveedor' label='Proveedor')
                              v-col(cols='12' sm='6' md='4' v-else)
                                v-text-field(dense outlined readonly v-model='editedItem.idProveedor.nombre' label='Proveedor')

                              v-col(cols='12' sm='6' md='4' )
                                v-text-field(dense outlined readonly v-model='editedItem.rif' label='Rif')
                              //- DetProductoOrden
                              v-col(cols='12' v-if="mostrarPro")
                                DetProductoOrden(:readHijo='read' :compra='editedItem' :detProductoOrden='detProductoOrden' :config='config.compras')
                      v-col( cols='12')
                        v-card(color='white' v-if='config.ordenCompra.valor')
                          v-card-subtitle.title(style='color: black') Proveedor
                          v-card-text
                            v-row(dense)
                              v-col(cols='12' sm='12' md='4' v-if="!read")
                                v-autocomplete(dense autocomplete="off" :menu-props="{closeOnContentClick: true}" outlined v-model='editedItem.idProveedor' :items="idProveedoresArray" @change="proveedorSeleccionado"
                                  label='Proveedor' :readonly='read')
                                  template(v-slot:prepend-item v-if="validarCrearProv()")
                                    v-list(dense)
                                      v-list-item( @click='prov = true')
                                        v-list-item-avatar(color='grey_1')
                                          v-btn.mx-2(fab dark x-small color='success')
                                            v-icon(dark small) mdi-plus
                                        v-list-item-content
                                          v-list-item-title
                                            | Agregar Proveedor
                                ProveedorM(:dialog='prov' :editedIndex='-1' @close='prov = false' @save='listarProveedores')
                              v-col(cols='12' sm='6' md='4' v-else)
                                v-text-field(dense outlined readonly v-model='nombreProveedor' label='Nombre')
                              v-col(cols='12' sm='6' md='4' )
                                v-text-field(dense outlined readonly v-model='editedItem.rif' label='Rif')
                              //- Hijo DetProductoOrden
                              v-col(cols='12' v-if="mostrarPro === true")
                                DetProductoOrden(:readHijo='read' :compra='editedItem' :detProductoOrden='detProductoOrden' :config='config.compras')

                      v-col(cols='12' v-if="!sinPro")
                        v-card(color='white')
                          v-card-text
                            //- Hijo DetProducto
                            v-row(dense)
                              v-col(cols='12' sm='12' md='12' )
                                DetProducto(:readHijo='read' :compra='editedItem' :detProducto='editedItem.detProducto' :config='config.compras')
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Montos
                          v-card-text
                            v-row(dense v-if="!sinPro")
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense readonly outlined :value='exento | read' label='Total Exento(IVA 0%)')
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense readonly outlined :value='reducido | read' label='Total Reducido(IVA 8%)')
                              v-col(cols='12' sm='12' md='4')
                                v-text-field(dense readonly outlined :value='gravado | read' label='Total Normal(IVA 16%)')
                            v-row(dense v-if="!sinPro")
                              v-col(cols='12' sm='12' md='6' class='d-flex justify-end')
                                v-text-field(dense outlined v-model.number='editedItem.subTotal' readonly label='Subtotal')
                              v-col(cols='12' sm='12' md='6' class='d-flex justify-end')
                                v-text-field(dense :readonly="!ingresarTotal" outlined v-model.number='editedItem.total' label='Total + IVA' @keyup="calculoTotal(editedItem.total, editedItem.totalDolar)" prefix="BsS" :disabled="!disabledBs")
                            v-row(class='d-flex justify-end' dense)
                              v-col(cols='12' sm='12' v-if="sinPro")
                                v-text-field(dense readonly outlined v-model.number='editedItem.totalBs' label='Total BsS' prefix="BsS" )
                              v-col(cols='12' sm='12')
                                v-text-field(dense :readonly="!ingresarTotal" outlined v-model.number='editedItem.totalDolar' label='Total USD' prefix="$" @keyup="calculoTotal(editedItem.total, editedItem.totalDolar)" :disabled="!disabledDolar")
                  v-card-actions
                    v-spacer
                    v-btn(color='error' small dark @click='close')
                      v-icon mdi-close
                      | Cancelar
                    v-btn(v-if='!read2' color='success' small dark @click='save')
                      v-icon mdi-content-save
                      | Guardar
        template(v-slot:item.fechaCreacion='{ item }')
          span {{item.fechaCreacion | moment('DD-MM-YYYY')}}
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='error' @click='editItem2(item)' v-on="on") mdi-undo-variant
            | Realizar Devolucion
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item,true)' v-on="on") mdi-eye
            | Visualizar
          //- v-tooltip(bottom='')
          //-   template(v-slot:activator='{ on }')
          //-     v-icon(v-if='validarEliminar()' color='red' @click='deleteItem(item)' v-on="on") mdi-delete
          //-   | Eliminar
            //- v-icon.mr-2(v-if='validarModificar()' color='yellow' @click='editItem(item,false)') mdi-pencil
        template(v-slot:no-data)
          h2.pa-2 No hay compras registradas

      v-dialog(v-model='devolucion' scrollable persistent content-class="flex xs12 sm8")
        v-card(color='grey_1')
          v-app-bar(dark color='primary')
            v-toolbar-title.headline Devolucion en la Compra
          v-spacer
          v-divider(light)
          v-card-text
            v-row(dense)
              v-col(cols='12')
                v-card(color='white')
                  v-card-subtitle.title(style='color: black') Detalle de la Nota
                  v-card-text
                    v-row(dense)
                      v-col(cols='6' sm='6' md='6')
                        v-autocomplete(dense label="Tipo de Nota de Debito" autocomplete="off" outlined v-model='editedItem.idTipoNotaDebito' :items="idTipoNotaDebitoArray")
                      v-col(cols='12' sm='12' md='12')
                        v-textarea(
                          auto-grow,
                          v-model='editedItem.observacion',
                          label="Motivo de la devolucion",
                          outlined,
                          dense,
                          v-uppercase)
              v-col(cols='12')
                v-card(color='white')
                  v-card-subtitle.title(style='color: black') Productos a Devolver
                  v-card-text
                    v-row(dense)
                      v-col(cols='12' sm='12' md='12')
                        v-data-table.elevation-1(:headers='headers2'  :items='editedItem.detProducto' :search='search')
                          template(v-slot:item.devuelto='props')
                            v-text-field(v-model.number='props.item.devuelto', @input='changeDevolver(props.item)' type="number" min="0" label='Cant. Devolver' single-line)
                          template(v-slot:top)
                            v-toolbar(flat color='primary' dark)
                              v-toolbar-title Productos
                              v-divider.mx-4(inset vertical)
                              v-spacer
                              v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
                              v-spacer
                          template(v-slot:no-data)
                            h2.pa-2 No hay Productos Asociados
                    v-row(dense class='d-flex justify-end')
                      v-col(cols='12' sm='12' md='3')
                          v-text-field(dense readonly outlined :value='editedItem.subTotal | read' label='Subtotal')
                      v-col(cols='12' sm='12' md='3')
                          v-text-field(dense readonly outlined :value='editedItem.totalIVA | read' label='Gravado')
                      //- v-col(cols='12' sm='12' md='3')
                      //-     v-text-field(dense readonly outlined :value='editedItem.exento | read' label='exento')
                      v-col(cols='12' sm='12' md='3')
                          v-text-field(dense readonly outlined :value='editedItem.total | read' label='Total + IVA')
          v-card-actions
            v-spacer
            v-btn(color='error' small dark @click='close2')
              v-icon mdi-close
              | Cancelar
            v-btn(v-if='!read2' color='success' small dark @click='save2')
              v-icon mdi-content-save
              | Guardar
</template>

<script>
import Api from '@/services/methods'
import DetProducto from '../components/DetProducto'
import DetProductoOrden from '../components/DetProductoOrden'
import ProveedorM from '../components/modals/ProveedorM'
import { EventBus } from '../Events'
export default {
  data: () => ({
    config: {
      ordenCompra: null,
      compras: null
    },
    exento: 0,
    gravado: 0,
    reducido: 0,
    idTipoNotaDebitoArray: [],
    notasDebito: [],
    devolucion: false,
    read: false,
    read2: false,
    valid: true,
    prov: false,
    dateEmision: new Date().toISOString().substr(0, 10),
    modalEmi: false,
    dateEmisionNota: new Date().toISOString().substr(0, 10),
    modalEmiNota: false,
    dateEmisionVen: new Date().toISOString().substr(0, 10),
    modalEmiVen: false,
    mostrarPro: false,
    dialog: false,
    dialogShow: false,
    dialog1: false,
    dialog2: false,
    loading: true,
    ingresarTotal: true,
    sinPro: false,
    headers: [],
    disabledBs: true,
    disabledDolar: true,
    headers0: [
      {
        text: 'Nro.Factura',
        align: 'left',
        value: 'numFactura'
      },
      { text: 'Nota Entrega', value: 'notaEntrega' },
      { text: 'Nro.Orden', value: 'nroOrden.numOrdenCompra' },
      { text: 'Proveedor', value: 'idProveedor.nombre' },
      { text: 'Rif del Proveedor', value: 'rif' },
      { text: 'Fecha Registro', value: 'fechaCreacion' },
      { text: 'Monto Total', value: 'showMonto' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    headers1: [
      {
        text: 'Nro.Factura',
        align: 'left',
        value: 'numFactura'
      },
      { text: 'Nota Entrega', value: 'notaEntrega' },
      { text: 'Fecha Registro', value: 'fechaCreacion' },
      { text: 'Fecha Vencimiento', value: 'fechaVencimiento' },
      { text: 'Monto Total (BsS)', value: 'total' },
      { text: 'Monto Total ($)', value: 'montoDolar' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    headers2: [
      { text: 'Codigo', align: 'left', sortable: false, value: 'idProducto.nombre' },
      { text: 'Producto', align: 'left', sortable: false, value: 'idProducto.descripcion' },
      { text: 'Cantidad', sortable: false, value: 'cantidadActual' },
      { text: 'Devolver', sortable: false, value: 'devuelto' },
      { text: 'IVA (%)', sortable: false, value: 'idIVA.descripcion' },
      { text: 'SubTotal', sortable: false, value: 'subTotal' },
      { text: 'Total', sortable: false, value: 'total' }
    ],
    tipoCom: ['Credito', 'Contado'],
    search: '',
    permisosRuta: {},
    permisosProveedor: {},
    compras: [],
    ordenes: [],
    doc: '',
    proveedores: [],
    idProveedoresArray: [],
    idOrdenesArray: [],
    editedIndex: -1,
    nombreProveedor: '',
    detProductoOrden: [],
    editedItem: {
      observacion: null,
      tipoCompra: '',
      nroOrden: null,
      numFactura: '',
      notaEntrega: '',
      rif: null,
      idProveedor: null,
      fechaEmision: '',
      fechaEmisionNota: '',
      fechaVencimiento: '',
      detProducto: [],
      subTotal: 0,
      totalIVA: 0,
      total: 0,
      idUsuario: '',
      exento: 0,
      tasaCompra: 0,
      totalDolar: 0,
      dolar: false,
      bs: true

    },
    defaultItem: {
      observacion: null,
      tipoCompra: '',
      nroOrden: null,
      numFactura: '',
      notaEntrega: '',
      rif: null,
      idProveedor: null,
      fechaEmision: '',
      fechaEmisionNota: '',
      fechaVencimiento: '',
      detProducto: [],
      subTotal: 0,
      totalIVA: 0,
      total: 0,
      idUsuario: '',
      exento: 0,
      tasaCompra: 0,
      totalDolar: 0,
      dolar: false,
      bs: true

    },
    documentos: ['Factura', 'Nota de Entrega'],
    mostrarNota: false,
    mostrarFact: false,
    mostrarPen: true
  }),
  components: {
    DetProducto,
    DetProductoOrden,
    ProveedorM
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Compra'
        : this.read
          ? 'Informacion de la Compra'
          : 'Modificar Compra'
    }
  },
  watch: {
    'editedItem.detProducto': function (val) {
      this.actualizacionIvas(val)
    },
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    EventBus.$on('productoOrden', data => {
      this.editedItem.detProducto.push(data)
      this.actualizacionIvas(this.editedItem.detProducto)
      this.calculos()
    })
    EventBus.$on('hijo', data => {
      this.actualizacionIvas(this.editedItem.detProducto)
      this.calculos()
    })
    this.initialize()
  },
  methods: {
    // Agregar formato de fecha y bs
    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD')
    },
    functionBs (val) {
      return Number.parseFloat(val).toFixed(2)
    },
    calculos () {
      this.editedItem.total = Number.parseFloat(this.editedItem.total)
      if (this.editedItem.detProducto.length > 0) {
        this.editedItem.subTotal = 0
        this.editedItem.totalIVA = 0
        this.editedItem.totalDolar = 0
        for (let i = 0; i < this.editedItem.detProducto.length; i++) {
          this.editedItem.detProducto[i].totalDolar = Number(this.editedItem.detProducto[i].totalDolar)
          this.editedItem.totalDolar += this.editedItem.detProducto[i].totalDolar
          this.editedItem.subTotal += this.editedItem.detProducto[i].subTotal
          this.editedItem.totalIVA +=
            this.editedItem.detProducto[i].total -
            this.editedItem.detProducto[i].subTotal
          this.ingresarTotal = false
        }
        this.editedItem.total = this.editedItem.subTotal + this.editedItem.totalIVA
        if (isNaN(this.editedItem.total)) {
          this.editedItem.total = 0
          this.editedItem.totalIVA = 0
          this.editedItem.subTotal = 0
          this.editedItem.totalDolar = 0
        }

        if (isNaN(this.editedItem.totalDolar)) {
          this.editedItem.totalDolar = 0
        }
      }
    },

    calculoTotal (totalBs, totalDolar) {
      if (this.editedItem.bs) {
        this.editedItem.totalDolar = totalBs / this.editedItem.tasaCompra
        this.editedItem.totalDolar = Number.parseFloat(this.editedItem.totalDolar).toFixed(2)
      } else {
        this.editedItem.total = totalDolar * this.editedItem.tasaCompra
        this.editedItem.total = Number.parseFloat(this.editedItem.total).toFixed(2)
      }
    },

    cambiarMonedaDolar () {
      const bool = this.editedItem.bs
      if (this.editedItem.detProducto.length > 0) {
        this.cambiarMoneda(true, false)
      } else {
        this.editedItem.dolar = !bool
        if (this.config.compras.detProducto.valor) {
          this.disabledBs = bool
          this.disabledDolar = !bool
        }
      }
    },

    cambiarMonedaBs () {
      const bool = this.editedItem.dolar
      if (this.editedItem.detProducto.length > 0) {
        this.cambiarMoneda(false, true)
      } else {
        this.editedItem.bs = !bool
        if (this.config.compras.detProducto.valor) {
          this.disabledDolar = bool
          this.disabledBs = !bool
        }
      }
    },

    cambiarMoneda (bs, dolar) {
      let moneda = ''
      bs ? moneda = 'Bolivares' : moneda = 'Dolares'
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres cambiar de moneda?',
        text: `Ya posees productos agregados con la moneda ${moneda}, si cambias de moneda
        todos los productos agregados previamente se borraran.`,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, cambiar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          if (this.editedItem.nroOrden) {
            this.editedItem.nroOrden = ''
            this.editedItem.idProveedor = ''
            this.nombreProveedor = ''
            this.editedItem.rif = ''
            this.detProductoOrden = []
            this.listarOrdenes()
          }
          this.editedItem.detProducto = []
          this.$swal.fire('Actualizado!', 'El cambio de moneda se ha realizado.', 'success')
          bs ? this.editedItem.dolar = !this.editedItem.bs : this.editedItem.bs = !this.editedItem.dolar
          this.editedItem.tasaCompra = 0
        } else {
          bs ? this.editedItem.bs = !this.editedItem.bs : this.editedItem.dolar = !this.editedItem.dolar
        }
      })
    },

    validarTasa (tasa) {
      if (this.config.compras.detProducto.valor) {
        this.disabledDolar = this.editedItem.dolar
        this.disabledBs = this.editedItem.bs
      }
      if (this.editedItem.detProducto.length > 0) {
        this.$swal({
          icon: 'warning',
          title: '¿Seguro que quieres cambiar de tasa?',
          text: `Ya posees productos agregados con la tasa a ${tasa}, si cambias la tasa todos los productos agregados previamente se borraran.`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, cambiar',
          cancelButtonText: 'cancelar'
        }).then(result => {
          if (result.value) {
            if (this.editedItem.nroOrden) {
              this.editedItem.nroOrden = ''
              this.editedItem.idProveedor = ''
              this.nombreProveedor = ''
              this.editedItem.rif = ''
              this.detProductoOrden = []
              this.listarOrdenes()
            }
            this.editedItem.detProducto = []
            this.$swal.fire('Actualizado!', 'El cambio de tasa se ha realizado.', 'success')
          }
        })
      } else if (this.editedItem.detProducto.length === 0 && this.config.compras.detProducto.valor && (this.editedItem.total > 0 || this.editedItem.totalDolar > 0)) {
        this.$swal({
          icon: 'warning',
          title: '¿Seguro que quieres cambiar de tasa?',
          text: `Ya posees calculos generados con la tasa a ${tasa}, si cambias la tasa todos los calculos previos se borraran.`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, cambiar',
          cancelButtonText: 'cancelar'
        }).then(result => {
          if (result.value) {
            this.editedItem.total = 0
            this.editedItem.totalDolar = 0
            this.$swal.fire('Actualizado!', 'El cambio de tasa se ha realizado.', 'success')
          }
        })
      }
    },

    actualizacionIvas (val) {
      this.gravado = 0
      this.exento = 0
      this.reducido = 0
      for (let i = 0; i < val.length; i++) {
        if (val[i].idIVA.descripcion === 'Reducido (8%)') {
          // console.log('Reducido (8%)')
          // this.reducido += val[i].subTotal * val[i].idIVA.valor
          this.reducido += val[i].total
        } else if (val[i].idIVA.descripcion === 'Exento (0%)') {
          // console.log('Exento (0%)')
          // this.exento += val[i].subTotal * val[i].idIVA.valor
          this.exento += val[i].total
        } else {
          // console.log('Normal (16%)')
          // this.gravado += val[i].subTotal * val[i].idIVA.valor
          this.gravado += val[i].total
        }
      }
      if (this.editedItem.detProducto.length > 0) {
        this.calculos()
      } else {
        this.editedItem.total = 0
        this.editedItem.totalIVA = 0
        this.editedItem.subTotal = 0
      }
    },
    editFact () {
      this.read2 = false
      this.editedItem.numFactura = ''
      this.editedItem.fechaEmision = ''
    },
    DocumentoSeleccionado (data) {
      if (data === 'Factura') {
        this.mostrarNota = false
        this.mostrarFact = true
        this.editedItem.numFactura = ''
        this.editedItem.fechaEmision = ''
        this.editedItem.notaEntrega = 'No tiene.'
        this.editedItem.fechaEmisionNota = ''
      } else {
        this.mostrarFact = false
        this.mostrarNota = true
        this.editedItem.notaEntrega = ''
        this.editedItem.fechaEmisionNota = ''
        this.editedItem.numFactura = 'Sin Nro.Factura.'
        this.editedItem.fechaEmision = ''
      }
    },
    OrdenSeleccionada (data) {
      const orden = this.ordenes.find(orden => orden._id === data)
      this.editedItem.idProveedor = orden.idProveedor._id
      this.nombreProveedor = orden.idProveedor.nombre
      this.editedItem.rif = orden.idProveedor.rif
      this.mostrarPro = true
      this.detProductoOrden = orden.productos
      // this.editedItem.detProducto = []
    },
    proveedorSeleccionado (data) {
      const proveedor = this.proveedores.find(pro => pro._id === data)
      this.editedItem.rif = proveedor.rif
      this.nombreProveedor = proveedor.nombre
    },
    initialize () {
      this.listarCompras()
      this.listarOrdenes()
      this.listarTipoNotaDebito()
      this.listarnotasDebito()
      this.listarProveedores()
      this.config.ordenCompra = this.$store.state.config.compras.ordenCompra
      this.config.compras = this.$store.state.config.compras
      if (!this.config.ordenCompra.valor) {
        this.headers = this.headers0
      } else {
        this.headers = this.headers1
        this.editedItem.ordenCompra = ''
        this.editedItem.idProveedor = ''
        this.editedItem.rif = ''
      }
      this.permisosRuta = this.$store.state.empresa[0].permisos.find(
        permiso => permiso.ruta === 'Compra'
      )
      this.permisosProveedor = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Proveedor')
    },
    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },
    validarCrearProv () {
      return this.permisosProveedor?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },
    formatoDecimal (i) {
      let n = parseFloat(i).toFixed(2)
      return Number(n).toLocaleString(
        'es-US',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      )
    },
    listarCompras () {
      Api.get('/compra')
        .then(response => {
          this.compras = response.data
          this.compras.map(data => {
            // data.fechaCreacion = this.formato(data.fechaCreacion)
            data.fechaEmision = this.formato(data.fechaEmision)
            data.fechaVencimiento = this.formato(data.fechaVencimiento)
            data.fechaEmisionNota = this.formato(data.fechaEmisionNota)
            data.fechaVen = this.formato(data.fechaVen)
            data.montoDolar = 0
            data.showMonto = this.formatoDecimal(data.total)
            if (data.totalDolar) data.montoDolar = data.totalDolar
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarOrdenes () {
      Api.get('/ordenCompra/generadas')
        .then(res => {
          this.ordenes = res.data
          this.idOrdenesArray = []
          this.ordenes.map(data => {
            this.idOrdenesArray.push({
              text: data.numOrdenCompra,
              value: data._id,
              idProveedor: data.idProveedor
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarProveedores () {
      Api.get('/proveedor')
        .then(response => {
          this.proveedores = response.data
          this.proveedores.map(data => {
            this.idProveedoresArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarnotasDebito () {
      Api.get('/notadebito')
        .then(response => {
          this.notasDebito = response.data
          this.loading = false
          this.notasDebito.map(data => {
            data.fechaCreacion = this.formato(data.fechaCreacion)
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarTipoNotaDebito () {
      Api.get('tiponotadebito')
        .then(res => {
          res.data.map(data => {
            this.idTipoNotaDebitoArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    editItem (item, bool) {
      this.editedIndex = this.compras.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.totalBs = item.total
      if (item.fechaEmision === 'Invalid date') {
        this.editedItem.fechaEmision = ''
      }
      if (bool && this.editedItem.idProveedor) {
        this.proveedorSeleccionado(this.editedItem.idProveedor._id)
      }
      if (item.detProducto.length === 0) {
        this.sinPro = true
      }
      this.ingresarTotal = false
      this.dialog = true
      this.read = bool
      this.read2 = this.read
      this.mostrarFact = true
      this.mostrarNota = true
    },
    editItem2  (item) {
      this.editedIndex = this.compras.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.devolucion = true
      this.editedItem.detProducto.map(prod => {
        prod.devuelto = 0
        prod.precioBs = prod.subTotal / prod.cantidadPedido
        prod.subTotal = 0
        prod.total = 0
      })
      this.editedItem.totalIVA = 0
      this.editedItem.subTotal = 0
      this.editedItem.total = 0
      this.validarDevolucion(this.editedItem)
    },
    validarDevolucion (item) {
      this.notasDebito.map(data => {
        if (data.idCompra._id === item._id) {
          if (data.idTipoNotaDebito.descripcion === 'DEVOLUCION TOTAL') {
            this.$swal({
              icon: 'error',
              title: 'Devolución total efectuada.',
              text: 'No puede realizar una nota de debito a esta factura.'
            })
            this.close2()
          }
        }
      })
    },
    changeDevolver (item) {
      let precio = item.costoU * item.devuelto
      let valorDesc = (item.porcDescuento / 100) * precio
      item.subTotal = precio /* + valorUti */ - valorDesc
      let valorIva = item.subTotal * item.idIVA.valor
      item.total = item.subTotal + valorIva
      this.calculos()
    },
    deleteItem (item) {
      const index = this.compras.indexOf(item)
      confirm('¿Esta seguro que desea Eliminar?') &&
        this.compras.splice(index, 1)
      Api.delete('/compra/' + item._id).then(response => {
      })
    },
    close () {
      this.dialog = false
      this.mostrarFact = false
      this.mostrarNota = false
      this.doc = ''
      this.sinPro = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem.detProducto = []
        this.editedIndex = -1
        this.nombreProveedor = ''
        this.exento = 0
        this.gravado = 0
        this.reducido = 0
        this.mostrarPro = false
        this.read = false
        this.read2 = false
      }, 300)
    },
    pendientes () {
      if (this.mostrarPen === true) {
        this.search = 'Sin Nro.Factura.'
        this.mostrarPen = false
      } else {
        this.search = ''
        this.mostrarPen = true
      }
    },
    validarCampos () {
      if (!this.editedItem.tipoCompra || !this.editedItem.idProveedor) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      if (this.doc === 'Factura') {
        if (this.editedItem.numFactura === '' || this.editedItem.fechaVencimiento === '' || this.editedItem.fechaEmision === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          return true
        }
      }
      if (this.doc === 'Nota de Entrega') {
        if (this.editedItem.notaEntrega === '' || this.editedItem.fechaEmisionNota === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          return true
        }
      }
      return false
    },
    validarNroOrden () {
      if (!this.config.ordenCompra.ordenCompra.valor) {
        if (this.editedItem.nroOrden === '') {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text: 'Por favor llene todos los campos para continuar'
          })
          return true
        }
      }
      return false
    },
    validaProductos () {
      if (this.editedItem.detProducto.length <= 0 && !this.config.compras.detProducto.valor) {
        this.$swal({
          icon: 'error',
          title: 'No existen productos cargados',
          text: 'Carge productos para emitir la Compra'
        })
        return true
      }
      return false
    },
    validarCuentas () {
      if (this.editedItem.total <= 0) {
        this.$swal({
          icon: 'error',
          title: 'El monto total no puede ser ' + this.editedItem.total,
          text: 'Verifique las cifras de los productos cargados'
        })
        return true
      }
      return false
    },
    validarCantidades () {
      for (let i = 0; i < this.editedItem.detProducto.length; i++) {
        if (this.editedItem.detProducto[i].devuelto > this.editedItem.detProducto[i].cantidadActual || !this.editedItem.detProducto[i].devuelto) {
          this.$swal({
            icon: 'error',
            title: 'Error en las cantidades',
            text: 'Las cantidades a devolver no pueden ser mayor a devolver'
          })
          return true
        }
      }
      return false
    },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },
    save () {
      if (
        !this.validarCampos() &&
        !this.validaProductos() &&
        !this.validarCuentas()
      ) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('/compra', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Actualizacion de compra exitosa',
                text: 'Has actualizado una compra'
              })
              this.listarCompras()
              this.listarOrdenes()
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          this.editedItem.idUsuario = this.$store.state.usuario._id
          if (this.editedItem.idProveedor === '') this.editedItem.idProveedor = null
          Api.post('/compra', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Registro de Compra Exitosa',
                text: 'Has registrado una Compra'
              })
              this.listarCompras()
              this.listarOrdenes()
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    },
    validarCampos2 () {
      if (!this.editedItem.observacion) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      if (!this.editedItem.idTipoNotaDebito) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },
    close2 () {
      this.devolucion = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.detProducto = []
      }, 300)
    },
    save2 () {
      if (!this.validarCantidades() && !this.validarCampos2()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => { this.$swal.showLoading() }
        })
        Api.post('notadebito', this.editedItem)
          .then(response => {
            this.$swal({
              icon: 'success',
              title: 'Creación exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.close2()
            this.listarCompras()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }
  }
}
</script>
<style lang="scss">
  @media screen and (max-width: 610px) {
    .header-toolbar-compras, .header-toolbar-compras .v-toolbar__content  {
      height: 100px !important;
      padding-top: 5px
    }

    .btn-main {
      margin-top: 5px;
    }
  }
  @media screen and (max-width: 425px) {
    .main-head {
      font-size: 1.3rem;
      .sub-head {
        font-size: 1.3rem !important;
      }
    }

    .search {
      width: 50%;
    }

  }
</style>
